module.exports = __webpack_public_path__ + "static/media/iconeCartao.4dd5dcdd.svg";